import React from 'react';
import useUser from '../UserProvider/useUser';
import {Route, Redirect} from 'react-router-dom';
import { Navigate, useLocation } from 'react-router-dom-v5-compat';
import { withGuard } from './GenericRouteGuard';


export const withPrivateRoute = (WrappedComponent, staticResource) => {
  return function PrivateRouteWrapper(props) {
    const { can } = useUser();
    return withGuard(WrappedComponent, can(staticResource))(props)
  };

}

const PrivateRoute = ({ children, resource, ...rest }) => {
    const {can, landingRoute} = useUser();

    return(
        <Route
            {...rest}
            render={({location}) =>
                (resource && can('READ', resource)) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: landingRoute(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute;
